import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-share-foko-dialog',
  templateUrl: './share-foko-dialog.component.html',
  styleUrls: ['./share-foko-dialog.component.css']
})
export class ShareFokoDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ShareFokoDialogComponent>, @Inject(MAT_DIALOG_DATA) public foko: any) {
    console.log("Foko: ", foko);
   }

   closeDialog() {
     this.dialogRef.close();
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/dialogs/share-foko-dialog/share-foko-dialog.component.ts